import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "column sfx-table__selection-header q-pl-sm q-pr-md" }

import { TABLE_SELECTION_ARROW_SIZE, TABLE_SELECTION_SIZE_PX } from "src/util/constants/table"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import {
  ReturnRowKey,
  RowData,
  SelectedKeys,
  SelectionOption,
  SelectionOptionFunction,
} from "src/util/types/components/sfxTable"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableThSelect',
  props: {
  selected: {
    type: Array as PropType<RowData[]>,
  },

  data: {
    type: Array as PropType<RowData[]>,
    required: true,
  },

  selectedKeys: {
    type: Object as PropType<SelectedKeys>,
    required: true,
  },

  getRowKey: {
    type: Function as PropType<ReturnRowKey>,
    required: true,
  },

  computedRows: {
    type: Array as PropType<RowData[]>,
  },

  selectionOptions: {
    type: Array as PropType<SelectionOption[]>,
  },

  disable: {
    type: Boolean,
  },
},
  emits: ["update:selected"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

// NOTE: Most of the functionality here related to the base QCheckbox,
// is directly taken from the internal implementation for the header selection in QTable

const { t } = useI18n()

// The computed rows from QTable is all the rows on the current page
const currentPageRows = computed(() => props.computedRows || [])

const selectedModel = computed<Array<RowData>>({
  get() {
    return props.selected || []
  },

  set(val) {
    emit("update:selected", val)
  },
})

const allRowsSelected = computed(
  () =>
    currentPageRows.value.length > 0 &&
    currentPageRows.value.every((row) => props.selectedKeys[props.getRowKey(row)] === true)
)

const someRowsSelected = computed(
  () =>
    !allRowsSelected.value &&
    currentPageRows.value.some((row) => props.selectedKeys[props.getRowKey(row)] === true)
)

const selectionModel = computed(() => (someRowsSelected.value ? null : allRowsSelected.value))

const predefinedSelectionOptions: SelectionOption[] = [
  {
    text: t("sfxTable.selection_all"),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateSelection: (row: RowData<unknown>) => true,
  },
  {
    text: t("sfxTable.selection_none"),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateSelection: (row: RowData<unknown>) => false,
  },
]

const allSelectionOptions = computed<SelectionOption[]>(() => {
  let options: SelectionOption[] = predefinedSelectionOptions

  if (props.selectionOptions && props.selectionOptions?.length > 0) {
    options = options.concat(props.selectionOptions)
  }

  return options
})

const isMenuOpen = ref(false)

const arrowClass = computed(() => {
  const arrow = "sfx-table__selection-header-arrow"
  const rotation = `${arrow}${isMenuOpen.value ? "-180" : "-0"}`
  const disable = { disabled: props.disable }

  return [arrow, rotation, disable]
})

//endregion

//region Functions

function updateCheckboxValue(val: boolean) {
  // We already have some rows marked as selected
  // So we want to force all the rows on the page to get de-selected
  if (someRowsSelected.value) {
    val = false
  }

  if (val) {
    selectedModel.value = selectedModel.value.concat(currentPageRows.value)
  } else {
    // De-select only the selected rows from this page
    selectedModel.value = selectedModel.value.filter(
      (row) => !currentPageRows.value.map((i) => props.getRowKey(i)).includes(props.getRowKey(row))
    )
  }
}

function updateSelection(callback: SelectionOptionFunction) {
  selectedModel.value = props.data.filter((i) => callback(i))
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_checkbox, {
      "model-value": selectionModel.value,
      "onUpdate:modelValue": updateCheckboxValue,
      size: _unref(TABLE_SELECTION_SIZE_PX),
      class: "sfx-table__checkbox",
      dense: "",
      color: "secondary",
      "checked-icon": "fa-solid fa-square",
      "indeterminate-icon": "fa-solid fa-hyphen",
      "unchecked-icon": "none",
      disable: props.disable
    }, null, 8, ["model-value", "size", "disable"]),
    _createVNode(_component_q_icon, {
      name: _unref(Icons).EXPAND,
      size: _unref(TABLE_SELECTION_ARROW_SIZE),
      class: _normalizeClass(arrowClass.value)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_menu, {
          modelValue: isMenuOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isMenuOpen).value = $event)),
          anchor: "bottom right",
          self: "top right",
          offset: [0, 10],
          "auto-close": "",
          class: "sfx-table__selection-menu",
          target: !props.disable
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, { class: "column q-pa-md gap-md" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSelectionOptions.value, (entry, index) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: index,
                    class: "sfx-table__selection-menu-item text-navy-base text-body1",
                    clickable: "",
                    onClick: ($event: any) => (updateSelection(entry.updateSelection))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(entry.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "target"])
      ]),
      _: 1
    }, 8, ["name", "size", "class"])
  ]))
}
}

})